import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "trigger-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "dropdown-menu"
}
const _hoisted_3 = ["onMouseover"]
const _hoisted_4 = ["id", "checked", "disabled", "onChange"]
const _hoisted_5 = ["for"]

import { ref, watch, onMounted, onUnmounted, PropType } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'MultiSelectPicker',
  props: {
  modelValue: {
    type: Array,
    default: () => [],
  },
  options: {
    type: Array,
    required: true,
  },
  idAttribute: {
    type: String,
    required: true,
  },
  displayAttribute: {
    type: String,
    required: true,
  },
  tooltip: {
    type: String,
    default: '',
  },
  dropdownAlignment: {
    type: String as PropType<'left' | 'right'>,
    default: 'right',
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const selectedIds = ref<string[]>([]);
const isOpen = ref(false);
const hoveredOptionId = ref<string | null>(null);

onMounted(() => {
  selectedIds.value = props.modelValue.map((o: any) => getIdValue(o));
});

watch(selectedIds, (newIds: string[]) => {
  const fullValues = props.options.filter((o: any) => newIds.includes(getIdValue(o)));
  emit('update:modelValue', fullValues);
});

// Close dropdown on outside click
const closeOnOutsideClick = (event: MouseEvent) => {
  const trigger = document.querySelector('.trigger-wrapper');
  if (trigger && !trigger.contains(event.target as Node)) {
    isOpen.value = false;
  }
};

onMounted(() => {
  document.addEventListener('click', closeOnOutsideClick);
});

onUnmounted(() => {
  document.removeEventListener('click', closeOnOutsideClick);
});

function isOptionSelected(option: any) {
  return selectedIds.value.some((id: string) => id === getIdValue(option));
}

function isOptionSelectedHover(option: any) {
  return getIdValue(option) === hoveredOptionId.value;
}

function onHover(option: any) {
  hoveredOptionId.value = getIdValue(option);
}

function isLastOptionSelected(option: any) {
  return isOptionSelected(option) && selectedIds.value.length === 1;
}

function getIdValue(option: any) {
  return option[props.idAttribute];
}

function getDisplayLabel(option: any) {
  return option[props.displayAttribute];
}

function onSelectionChanged(option: any, checked: boolean) {
  const affectedId = getIdValue(option);
  let newIdValues = [...selectedIds.value];

  if (checked) {
    if (affectedId && !newIdValues.some((id) => id === affectedId)) {
      newIdValues.push(affectedId);
    }
  } else {
    newIdValues = newIdValues.filter((id: string) => id !== affectedId);
  }
  // Enforce at least one option selected (equivalent to allow-empty="false")
  if (newIdValues.length === 0 && props.options.length > 0) {
    newIdValues = [getIdValue(props.options[0])];
  }
  selectedIds.value = newIdValues;
}

return (_ctx: any,_cache: any) => {
  const _component_n_tooltip = _resolveComponent("n-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["multiselect-container", __props.dropdownAlignment])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_n_tooltip, {
        position: "left",
        text: __props.tooltip
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            class: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = !isOpen.value))
          }, [
            _renderSlot(_ctx.$slots, "button-display")
          ])
        ]),
        _: 3
      }, 8, ["text"]),
      (isOpen.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
              return (_openBlock(), _createElementBlock("div", {
                key: getIdValue(option),
                class: _normalizeClass(["option__content", { 'is-selected': isOptionSelected(option), 'is-hover': isOptionSelectedHover(option) }]),
                onMouseover: ($event: any) => (onHover(option)),
                onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (hoveredOptionId.value = null))
              }, [
                _createElementVNode("input", {
                  type: "checkbox",
                  id: getIdValue(option),
                  checked: isOptionSelected(option),
                  disabled: isLastOptionSelected(option),
                  onChange: (e) => onSelectionChanged(option, (e.target as HTMLInputElement).checked)
                }, null, 40, _hoisted_4),
                _createElementVNode("label", {
                  for: getIdValue(option),
                  class: "option__title"
                }, _toDisplayString(getDisplayLabel(option)), 9, _hoisted_5)
              ], 42, _hoisted_3))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})